import { monthNames } from './timeline-timeframes';

export function buildDateString({ date }: { date: Date }): string {
  const day = date.getDate().toString().padStart(2, '0');

  return `${monthNames[date.getMonth()]} ${day}`;
}
